<section class="container">
  <div class="d-flex justify-content-end">
    <button [disabled]="programasPermitidos.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportar()"
            placement="top" ngbTooltip="Exporta os programas listados">
      <i class="fa fa-file"></i> Exportar Programas</button>
  </div>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th scope="col" class="text-nowrap align-top">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'id'"
            [nomeAtributoExibicao]="'Códigos dos Programas no OPE'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th scope="col" class="text-nowrap align-top">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'descricaoPrograma'"
            [nomeAtributoExibicao]="'Descrição do programa'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th scope="col" class="text-nowrap align-top">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'indicadorEsco'"
            [nomeAtributoExibicao]="'ESCO'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th scope="col" class="text-nowrap align-top">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'aceitaBeneficiarioCpfRepasse'"
            [nomeAtributoExibicao]="'Aceita PF'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th scope="col" class="text-nowrap align-top">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'desconsiderarPrazoTotalMaximoContratual'"
            [nomeAtributoExibicao]="'Desconsiderar Prazo'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th scope="col" class="text-nowrap align-top">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'abonoEcg'"
            [nomeAtributoExibicao]="'Abono ECG'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of programasPermitidos" [class.destacar-td]="isDestacarLinha(item)">
        <td>{{"000000" + item.id | slice:-6 }}</td>
        <td>{{item.descricaoPrograma == undefined ? '' : item.descricaoPrograma}} </td>
        <td>{{item.indicadorEsco == undefined ? 'N/A' : (item.indicadorEsco ? 'S' : 'N')}} </td>
        <td>{{item.aceitaBeneficiarioCpfRepasse == undefined ? 'N/A' : (item.aceitaBeneficiarioCpfRepasse ? 'S' : 'N')}} </td>
        <td>{{item.desconsiderarPrazoTotalMaximoContratual == undefined ? 'N/A' : (item.desconsiderarPrazoTotalMaximoContratual ? 'S' : 'N')}} </td>
        <td>{{item.abonoEcg == undefined ? 'N/A' : (item.abonoEcg ? 'S' : 'N')}} </td>
        <td class="text-start text-nowrap" *ngIf="permissaoGestorEnvio" id=col-acoes>
          <a href="javascript:void(0)" (click)="excluiRepasse(item.id)">
            <i class="fa fa-trash cursor-pointer" placement="left-top" ngbTooltip="Excluir programa"></i>
          </a>
          <a href="javascript:void(0)" (click)="editarRepasse(item)" class="ms-3">
            <i class="fa fa-pencil cursor-pointer" placement="left-top" ngbTooltip="Editar programa"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</section>
